import { Reveal } from "@components/ui";
import circularImg from "@assets/images/Group-1410087743@2x.png";

const cards = [
  {
    title: "Pipeline Integrity",
    description: "Smart monitoring extends infrastructure lifespan, reducing waste and replacement needs.",
    color: "#122d63",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
      </svg>
    ),
  },
  {
    title: "Waste Minimization",
    description: "Systematic reduction through process optimization and recycling programs.",
    color: "#1a7a4f",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="1 4 1 10 7 10" />
        <polyline points="23 20 23 14 17 14" />
        <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" />
      </svg>
    ),
  },
  {
    title: "Resource Recovery",
    description: "Reusing materials wherever possible, turning waste into valuable resources.",
    color: "#d4880f",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      </svg>
    ),
  },
  {
    title: "Digital Operations",
    description: "Paperless workflows reducing the environmental impact of daily operations.",
    color: "#6b4fc7",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
  },
];

const CircularThinkingSection = () => {
  return (
    <section className="bg-white py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal>
          <div className="flex flex-col items-center text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#1a7a4f]/10 text-[#1a7a4f] text-[14px] md:text-[16px] font-medium tracking-[-0.04em] mb-4">
              Environment
            </span>
            <h2 className="text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63]">
              Minimizing Impact Through Circular Thinking
            </h2>
            <p className="text-[20px] md:text-[24px] lg:text-[28px] text-[#62636c] tracking-[-0.04em] mt-3 max-w-[700px]">
              Our approach to waste reduction and resource optimization
            </p>
          </div>
        </Reveal>

        {/* Two-column: cards left, image right */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {cards.map((card) => (
              <Reveal key={card.title} className="h-full">
                <div className="group relative rounded-[20px] bg-white border border-[rgba(98,99,108,0.2)] p-5 overflow-hidden hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300 h-full">
                  {/* Top accent */}
                  <div
                    className="absolute top-0 left-0 right-0 h-1 rounded-t-[20px]"
                    style={{ backgroundColor: card.color }}
                  />

                  <div
                    className="w-10 h-10 rounded-[12px] flex items-center justify-center text-white mb-3 group-hover:scale-110 transition-transform duration-300"
                    style={{ backgroundColor: card.color }}
                  >
                    {card.icon}
                  </div>

                  <h3 className="text-[18px] md:text-[20px] font-semibold text-[#090d2c] tracking-[-0.04em] mb-1.5">
                    {card.title}
                  </h3>
                  <p className="text-[14px] md:text-[16px] text-[rgba(10,14,46,0.7)] tracking-[-0.04em] leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>

          {/* Image */}
          <Reveal>
            <div className="flex justify-center">
              <img
                src={circularImg}
                alt="Circular economy approach"
                className="w-full max-w-[500px] rounded-[24px]"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default CircularThinkingSection;
